var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageFile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1667 17.8063C19.1667 18.5577 18.644 19.1667 18 19.1667H4L12.827 11.2135C13.114 10.9277 13.6343 10.9288 13.9155 11.2123L19.1667 16.4367V17.8063ZM6.33333 5.16667C7.29933 5.16667 8.08333 5.95067 8.08333 6.91667C8.08333 7.88267 7.29933 8.66667 6.33333 8.66667C5.36733 8.66667 4.58333 7.88267 4.58333 6.91667C4.58333 5.95067 5.36733 5.16667 6.33333 5.16667ZM18 0.5H4C2.07033 0.5 0.5 2.07033 0.5 4V18C0.5 19.9297 2.07033 21.5 4 21.5H18C19.9297 21.5 21.5 19.9297 21.5 18V4C21.5 2.07033 19.9297 0.5 18 0.5Z",
    fill: "#7B819B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageFile);
export default __webpack_public_path__ + "static/media/imageFile.8929322722dd3251fae373681e4ab2b7.svg";
export { ForwardRef as ReactComponent };